module.exports = __webpack_public_path__ + "img/XZC.800e1eeb.svg";